import { Button, ButtonProps, TooltipProps } from '@wix/design-system';
import React from 'react';
import { DisabledTooltip } from '../DisabledTooltip';

export type BulkActionButtonProps = ButtonProps & {
  tooltipText?: string;
  tooltipProps?: Partial<TooltipProps>;
};

export function BulkActionButton(props: BulkActionButtonProps) {
  const { tooltipText, tooltipProps, ...rest } = props;
  return (
    <DisabledTooltip
      content={tooltipText}
      dataHook="bulk-action-button-tooltip"
      {...tooltipProps}
    >
      <Button
        dataHook="bulk-action-button"
        skin="standard"
        priority="secondary"
        {...rest}
      />
    </DisabledTooltip>
  );
}
